import axios from 'axios';
import $ from 'jquery';

let isRefreshingToken = false;
let refreshSubscribers = [];

function onRefreshed(newSid) {
    refreshSubscribers.forEach(cb => cb(newSid));
    refreshSubscribers = [];
}

function updatePayloadWithNewSid(data, newSid) {
    if (!data) return data;
    
    if (typeof data === 'string') {
        // e.g. "sid=old_sid&other=param"
        return data.replace(/(^|&)sid=[^&]*/g, '$1sid=' + encodeURIComponent(newSid));
    } else if (data instanceof FormData) {
        if (typeof data.set === 'function') {
            data.set('sid', newSid);
        } else {
            // older browsers, fallback
            data.delete('sid');
            data.append('sid', newSid);
        }
        return data;
    } else if (typeof data === 'object') {
        data.sid = newSid;
        return data;
    }
    return data;
}

const originalAjax = $.ajax;

$.ajax = function(options) {
    const deferred = $.Deferred();

    function doRequest(opts) {
        originalAjax(opts)
            .done(function(data, textStatus, jqXHR) {
                if (data && data.status === 'auth failed2') {
                    handleAuthFailure(
                        (newSid) => {
                            opts.data = updatePayloadWithNewSid(opts.data, newSid);
                            doRequest(opts);
                        },
                        () => deferred.resolve(data, textStatus, jqXHR)
                    );
                } else {
                    deferred.resolve(data, textStatus, jqXHR);
                }
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                deferred.reject(jqXHR, textStatus, errorThrown);
            });
    }

    doRequest(options);

    const promise = deferred.promise();
    promise.abort = function() {
       // Mock abort function to prevent undefined errors
    };
    return promise;
};

axios.interceptors.response.use(
    function (response) {
        if (response.data && response.data.status === 'auth failed2') {
            return new Promise((resolve, reject) => {
                handleAuthFailure(
                    (newSid) => {
                        const config = response.config;
                        config.data = updatePayloadWithNewSid(config.data, newSid);
                        axios.request(config).then(resolve).catch(reject);
                    },
                    () => resolve(response)
                );
            });
        }
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

function handleAuthFailure(onSuccess, onFailure) {
    if (!isRefreshingToken) {
        isRefreshingToken = true;

        const user_details_str = window.localStorage.getItem("user_details_alsafas_emak_app");
        if (user_details_str) {
            let user_details;
            try {
                user_details = JSON.parse(user_details_str);
            } catch (e) {
                isRefreshingToken = false;
                onFailure();
                return;
            }

            const oldSid = user_details.sid;
            
            originalAjax({
                url: process.env.REACT_APP_SSS + "/api/checkLoginToken",
                data: {
                    "sid": oldSid,
                    "version": window.app_version || '1.0'
                },
                type: "POST"
            }).done(function(return_data) {
                if (return_data && return_data.status === "success") {
                    delete return_data.status;
                    return_data.username = user_details.username;
                    return_data.password = user_details.password;
                    
                    window.localStorage.setItem("user_details_alsafas_emak_app", JSON.stringify(return_data));
                    
                    const event = new CustomEvent("auth_token_updated", { detail: return_data });
                    window.dispatchEvent(event);

                    isRefreshingToken = false;
                    onRefreshed(return_data.sid);
                    onSuccess(return_data.sid);
                } else {
                    isRefreshingToken = false;
                    onFailure();
                }
            }).fail(function() {
                isRefreshingToken = false;
                onFailure();
            });
        } else {
            isRefreshingToken = false;
            onFailure();
        }
    } else {
        refreshSubscribers.push(onSuccess);
    }
}
